export const WHATSAPP_NUMBER = "5531987936827";
export const PHONE_DISPLAY = "(31) 98793-6827";
export const EMAIL = "atendimento@goldservicemg.com.br";
export const LANDLINES = [
  { display: "(31) 2568-0969", tel: "+553125680969" },
  { display: "(31) 3354-0328", tel: "+553133540328" },
];
export const INSTAGRAM_URL = "https://instagram.com/goldservicemg";
export const TIKTOK_URL = "https://tiktok.com/@goldservicemg";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_WA_MSG =
  "Olá, Gold Service! Vim pelo site e gostaria de solicitar um orçamento.";

export const SERVICES = [
  {
    id: "dedetizacao",
    title: "Dedetização",
    subtitle: "Insetos rasteiros e voadores",
    description:
      "Eliminação de baratas, Escorpião, Formigas, Aranhas e Mosquitos com formulações sem cheiro e alto efeito residual.",
    image: "/images/pest-cockroach.webp",
    badge: "Mais solicitado",
  },
  {
    id: "desratizacao",
    title: "Desratização",
    subtitle: "Controle de roedores",
    description:
      "Mapeamento de trilhas, porta-iscas de alta segurança e selamento de acessos contra ratos e camundongos.",
    image: "/images/pest-rat.webp",
    badge: "Segurança sanitária",
  },
  {
    id: "descupinizacao",
    title: "Descupinização",
    subtitle: "Cupins e brocas",
    description:
      "Proteção profunda contra cupins de solo e madeira seca, preservando móveis, telhados e estruturas.",
    image: "/images/pest-termite.webp",
    badge: "Proteção patrimonial",
  },
  {
    id: "limpeza-caixa-dagua",
    title: "Limpeza de Caixa d'Água",
    subtitle: "Higienização com laudo",
    description:
      "Higienização e desinfecção de reservatórios em conformidade com as normas da Vigilância Sanitária.",
    image: "/images/water-tank-cleaning-1.webp",
    badge: "Norma Anvisa",
  },
  {
    id: "limpeza-caixa-gordura",
    title: "Limpeza de Caixa de Gordura",
    subtitle: "Preventiva e corretiva",
    description:
      "Remoção de resíduos graxos, fim dos maus odores e prevenção de entupimentos na rede de esgoto.",
    image: "/images/solucoes.jpeg",
    badge: "Comercial & industrial",
    dim: true,
  },
  {
    id: "desentupimento",
    title: "Desentupimento",
    subtitle: "Desobstrução hidráulica",
    description:
      "Equipamentos rotativos e de alta pressão para pias, ralos e colunas — sem quebrar estruturas.",
    image: "/images/7.jpeg",
    badge: "Atendimento rápido",
  },
  {
    id: "capina-quimica",
    title: "Capina Química",
    subtitle: "Controle de mato e invasoras",
    description:
      "Aplicação herbicida controlada em terrenos, lotes e margens, com eliminação total do mato e efeito prolongado.",
    image: "/images/capina-antes.jpg",
    badge: "Terrenos & lotes",
  },
  {
    id: "luminarias-uv",
    title: "Luminárias UV",
    subtitle: "Armadilhas luminosas",
    description:
      "Instalação e monitoramento de luminárias UV para controle de insetos voadores em cozinhas e indústrias.",
    image: "/images/luminarias-antes-depois.png",
    badge: "Tecnologia UV",
  },
];

export const CLIENTS = [
  "Construtora Barbosa Mello",
  "Minasmáquinas",
  "Endolog",
  "ABB",
  "Unimed BH",
  "Expresso 2000",
  "Prefeitura de Ibirité",
];

export const GOOGLE_REVIEW_URL = "https://share.google/2kkO2Lqumwb0hKFGm";

export const TIKTOK_VIDEO_ID = "7673240151715237128";

export const GALLERY_CASES = [
  {
    id: "luminarias-uv",
    title: "Luminárias UV",
    subtitle: "Troca e higienização em cozinha industrial",
    imageAntes: "/images/luminarias-antes.jpg",
    imageDepois: "/images/luminarias-depois.jpg",
  },
  {
    id: "caixa-azul",
    title: "Caixa d'Água",
    subtitle: "Higienização completa de reservatório",
    imageAntes: "/images/caixa-azul-antes.jpg",
    imageDepois: "/images/caixa-azul-depois.jpg",
  },
  {
    id: "cisterna",
    title: "Caixa d'Água — Cisterna",
    subtitle: "Limpeza pesada com equipe protegida",
    imageAntes: "/images/cisterna-antes.jpg",
    imageDepois: "/images/cisterna-depois.jpg",
  },
  {
    id: "capina-quimica",
    title: "Capina Química",
    subtitle: "Terreno limpo, sem queimada e sem esforço",
    imageAntes: "/images/capina-antes.jpg",
    imageDepois: "/images/capina-depois.jpg",
  },
];

export const MARQUEE_ITEMS = [
  "Gold Service BH",
  "Controle Integrado de Ambientes",
  "Atendimento 24h",
  "Dedetização",
  "Desratização",
  "Descupinização",
  "Limpeza de Caixa d'Água",
  "Desentupimento",
  "Luminárias UV",
];
